import { render } from "./customerSettings.vue?vue&type=template&id=f58d50f2&scoped=true"
import script from "./customerSettings.vue?vue&type=script&lang=js"
export * from "./customerSettings.vue?vue&type=script&lang=js"

import "./customerSettings.vue?vue&type=style&index=0&id=f58d50f2&lang=scss&scoped=true"

import exportComponent from "D:\\Project\\website-shuziyun\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f58d50f2"]])

export default __exports__